export default {
	serviceProvider: null,
	vuexModule: "members",
	queryParams: {
		company_id: null,
		type: "Corporate Admin",
	},
	headerColumns: [
		{
			prop: "user",
			label: "Name",
			minWidth: 220,
			sortable: true,
			sortBy: "user.first_name",
		},
		{
			prop: "user_email",
			label: "Email",
			minWidth: 220,
			sortable: true,
			sortBy: "user_email",
		},
		{
			prop: "cash_call_approver",
			label: "Cash Call Approver",
			minWidth: 220,
			sortable: true,
		},
        {
			prop: "billing_contact",
			label: "Billing Contact",
			minWidth: 200,
			sortable: true,
		},
        {
			prop: "status",
			label: "Status",
			width: 180,
			sortable: true,
		},
	],
};
